export const acquireConstants = {
    GET_COMPANY_ACQUIRE_CAMPAIGNS_REQUEST: 'GET_COMPANY_ACQUIRE_CAMPAIGNS_REQUEST',
    GET_COMPANY_ACQUIRE_CAMPAIGNS_SUCCESS: 'GET_COMPANY_ACQUIRE_CAMPAIGNS_SUCCESS',
    GET_COMPANY_ACQUIRE_CAMPAIGNS_FAILURE: 'GET_COMPANY_ACQUIRE_CAMPAIGNS_FAILURE',

    GET_COMPANY_ACQUIRE_METRICS_REQUEST: 'GET_COMPANY_ACQUIRE_METRICS_REQUEST',
    GET_COMPANY_ACQUIRE_METRICS_SUCCESS: 'GET_COMPANY_ACQUIRE_METRICS_SUCCESS',
    GET_COMPANY_ACQUIRE_METRICS_FAILURE: 'GET_COMPANY_ACQUIRE_METRICS_FAILURE',

    GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_REQUEST: 'GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_REQUEST',
    GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_SUCCESS: 'GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_SUCCESS',
    GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_FAILURE: 'GET_ORGANIZATION_ACQUIRE_CAMPAIGNS_FAILURE',

    GET_ORGANIZATION_ACQUIRE_METRICS_REQUEST: 'GET_ORGANIZATION_ACQUIRE_METRICS_REQUEST',
    GET_ORGANIZATION_ACQUIRE_METRICS_SUCCESS: 'GET_ORGANIZATION_ACQUIRE_METRICS_SUCCESS',
    GET_ORGANIZATION_ACQUIRE_METRICS_FAILURE: 'GET_ORGANIZATION_ACQUIRE_METRICS_FAILURE',
}